import React from 'react';

import { IStockTransferItemProps, TableConfig } from 'commons/types';
import { formatDate } from 'commons/utils/formatDate';

export const summaryTableConfig: TableConfig = [
  {
    header: 'Bin',
    key: 'bin',
  },
  {
    header: 'Batch',
    key: 'inventory_number',
  },
  {
    header: 'Bin Type',
    key: 'bin_type',
  },
  {
    header: 'Expiry Date',
    element: (item: IStockTransferItemProps): React.ReactElement => {
      const date = formatDate(item.expiry_date);
      return <div>{date}</div>;
    },
  },
  {
    header: 'Qty',
    key: 'quantity',
  },
];
